import {
  Box as Flex,
  Typography as Text,
  makeStyles,
  styled,
} from '@material-ui/core';

import classNames from 'classnames';

import { extractLastNameComponent } from '@spotify/confidence-core-react';
import { ActivityItem } from '@spotify/plugin-confidence-activity-react';

import type { Rule } from './types';

const EnvironmentChip = styled(Text)({
  background: 'var(--bui-bg-surface-1)',
  display: 'inline-flex',
  padding: 'var(--bui-space-1) var(--bui-space-2)',
  borderRadius: 'var(--bui-radius-2)',
});

const useStyles = makeStyles({
  added: {
    color: 'var(--bui-fg-success)',
    background: 'var(--bui-bg-success)',
  },
  removed: {
    color: 'var(--bui-fg-secondary)',
    textDecoration: 'line-through',
  },
});

export const EnvironmentsSection = ({
  oldRule,
  newRule,
}: {
  oldRule?: Rule;
  newRule?: Rule;
}) => {
  const classes = useStyles();

  if (!oldRule?.environments?.length && !newRule?.environments?.length) {
    return null;
  }

  const oldEnvironments =
    oldRule?.environments?.map(environment => environment.name) ?? [];
  const newEnvironments =
    newRule?.environments?.map(environment => environment.name) ?? [];
  const environments = Array.from(
    new Set([...oldEnvironments, ...newEnvironments]),
  );

  return (
    <ActivityItem.Section label="Environments">
      <Flex
        display="flex"
        flexDirection="row"
        alignItems="flex-start"
        style={{
          gap: 'var(--bui-space-1)',
        }}
      >
        {environments.map(environment => (
          <EnvironmentChip
            key={environment}
            variant="body1"
            className={classNames({
              [classes.added]:
                newEnvironments.includes(environment) &&
                !oldEnvironments.includes(environment) &&
                oldRule &&
                newRule,
              [classes.removed]:
                oldEnvironments.includes(environment) &&
                !newEnvironments.includes(environment) &&
                oldRule &&
                newRule,
            })}
          >
            {extractLastNameComponent(environment)}
          </EnvironmentChip>
        ))}
      </Flex>
    </ActivityItem.Section>
  );
};
